module.exports = __webpack_public_path__ + "img/hospital-image-1.cbb6ddf2.jpg";